const baseUrl = import.meta.env.SERVER_BASE_URL ?? '';

export default Object.freeze({
    baseUrl,
    authPath: baseUrl + '/auth',
    apiPath: baseUrl + (import.meta.env.SERVER_API_PATH ?? '/api'),
    recaptchaSiteKey: import.meta.env.RECAPTCHA_SITE_KEY,
    mediaMaxFileSize: import.meta.env.MEDIA_MAX_FILE_SIZE ? parseInt(import.meta.env.MEDIA_MAX_FILE_SIZE) : 15_728_640,
    mediaMaxFileCount: import.meta.env.MEDIA_MAX_FILE_COUNT ? parseInt(import.meta.env.MEDIA_MAX_FILE_COUNT) : 8,
    sentryDSN: import.meta.env.SENTRY_DSN,
    sentryTracesSampleRate: import.meta.env.SENTRY_TRACES_SAMPLE_RATE ? parseFloat(import.meta.env.SENTRY_TRACES_SAMPLE_RATE) : 0.1,
    sentryReplaysSessionSampleRate: import.meta.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE ? parseFloat(import.meta.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) : 0.1,
    sentryReplaysOnErrorSampleRate: import.meta.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ? parseFloat(import.meta.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) : 1.0,
    siteId: import.meta.env.SITE_ID ?? 'xprt_dev',
    clientBaseURL: import.meta.env.CLIENT_BASE_URL ?? 'https://xprt.dev',
    xprtJobsBaseUrl: import.meta.env.XPRT_JOBS_BASE_URL ?? 'https://xprt.jobs',
    umamiWebsiteId: import.meta.env.VUE_APP_UMAMI_WEBSITE_ID,
    umamiScriptSrc: import.meta.env.VUE_APP_UMAMI_SCRIPT_SRC
});
